<template>
  <div class="switcher">
    <div class="switcher__button" @click="turn">
      <slot name="switcher" v-bind:classes="{ active: classes.displayed }" />
    </div>
    <div class="switcher__body" :class="classes">
      <slot v-if="$props.render || classes.displayed" />
    </div>
  </div>
</template>

<script>
  export default {
    name: "Switcher",
    data() {
      return {
        classes: {
          displayed: this.$props.display,
        },
      };
    },
    props: {
      onShow: Function,
      onClose: Function,
      display: Boolean,
      render: Boolean,
      turnable: Boolean,
    },
    methods: {
      show() {
        if (!this.classes.displayed) {
          this.onShow && this.onShow(this);
          this.classes.displayed = true;
        }
        const parent = this.$parent;
        if (parent.switcherShow) {
          parent.switcherShow(this);
        }
        this.$emit('show', this);
      },
      close() {
        if (this.classes.displayed) {
          this.onClose && this.onClose(this);
          this.classes.displayed = false;
        }
        this.$emit('close', this);
      },
      turn() {
        if (this.$props.turnable || !this.classes.displayed) {
          this.classes.displayed ? this.close() : this.show();
        }
      },
    },
    computed: {
      isDisplayed: s => s.classes.displayed,
    },
    created() {
      if (this.$props.display) {
        this.classes.displayed = true;
      }
    },
    beforeMount() {
      const parent = this.$parent;
      if (parent.addSwitcher) {
        parent.addSwitcher(this);
      }
    },
    beforeUnmount() {
      const parent = this.$parent;
      if (parent.removeSwitcher) {
        parent.removeSwitcher(this);
      }
    }
  }
</script>
